var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0691 21.0406V27.2224C11.0691 27.6588 10.715 28.0127 10.279 28.0127C9.84264 28.0127 9.48877 27.6586 9.48877 27.2224V21.0406C9.737 21.1241 10.0027 21.1693 10.279 21.1693C10.5551 21.1693 10.8208 21.1241 11.0691 21.0406ZM9.48877 16.3278V7.50771C9.48877 7.07133 9.8428 6.71747 10.279 6.71747C10.715 6.71747 11.0691 7.0715 11.0691 7.50771V16.3278C10.8208 16.2444 10.5551 16.1994 10.279 16.1994C10.0027 16.1994 9.737 16.2446 9.48877 16.3278Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2791 15.4092C8.47136 15.4092 7.00391 16.8766 7.00391 18.6844C7.00391 20.4919 8.47131 21.9593 10.2791 21.9593C12.0865 21.9593 13.554 20.4919 13.554 18.6844C13.554 16.8767 12.0866 15.4092 10.2791 15.4092ZM10.2791 16.9897C11.2144 16.9897 11.9736 17.7489 11.9736 18.6842C11.9736 19.6196 11.2144 20.3787 10.2791 20.3787C9.34382 20.3787 8.58459 19.6195 8.58459 18.6842C8.58459 17.7489 9.34382 16.9897 10.2791 16.9897Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2339 24.3168C24.4821 24.4003 24.7478 24.4452 25.0239 24.4452C25.3003 24.4452 25.5659 24.4003 25.8142 24.3168V27.2226C25.8142 27.6589 25.4601 28.0128 25.0239 28.0128C24.5879 28.0128 24.2339 27.6588 24.2339 27.2226V24.3168ZM24.2339 19.604V7.50813C24.2339 7.07176 24.5879 6.7179 25.0239 6.7179C25.4604 6.7179 25.8142 7.07192 25.8142 7.50813V19.604C25.5659 19.5206 25.3003 19.4756 25.0239 19.4756C24.7478 19.4756 24.4821 19.5208 24.2339 19.604Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0234 23.6555C24.088 23.6555 23.3289 22.8959 23.3289 21.9609C23.3289 21.0256 24.0881 20.2661 25.0234 20.2661C25.9587 20.2661 26.7179 21.0256 26.7179 21.9609C26.7179 22.8961 25.9587 23.6555 25.0234 23.6555Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4413 15.1266V27.2224C18.4413 27.6588 18.0871 28.0127 17.6511 28.0127C17.2151 28.0127 16.8608 27.6587 16.8608 27.2224V15.1266C17.1092 15.2099 17.375 15.255 17.6511 15.255C17.9272 15.255 18.1929 15.2098 18.4413 15.1266ZM16.8608 10.4138V7.50801C16.8608 7.07163 17.2151 6.71777 17.6511 6.71777C18.0871 6.71777 18.4413 7.0718 18.4413 7.50801V10.4138C18.1929 10.3303 17.9272 10.2854 17.6511 10.2854C17.375 10.2854 17.1092 10.3303 16.8608 10.4138Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6512 11.0757C18.5865 11.0757 19.3457 11.8353 19.3457 12.7702C19.3457 13.7056 18.5864 14.4651 17.6512 14.4651C16.7159 14.4651 15.9566 13.7055 15.9566 12.7702C15.9566 11.8351 16.7159 11.0757 17.6512 11.0757Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreads);
export default __webpack_public_path__ + "static/media/threads.ea169e0f951c9957bb74e2adecb65d58.svg";
export { ForwardRef as ReactComponent };